/**
 * Landing Eclipse: filtrado del grid por ciudad/país (tabs) y "Ver más experiencias".
 * Todo client-side sobre el HTML cacheado del servidor.
 */
(function () {
	'use strict';

	var LIMIT = 9;

	document.addEventListener('DOMContentLoaded', function () {
		var catalogue = document.getElementById('eclipse-catalogue');
		if (!catalogue) {
			return;
		}
		var tabs = catalogue.querySelectorAll('.eclipse-tabs__tab');
		var items = Array.prototype.slice.call(catalogue.querySelectorAll('.eclipse-grid__item'));
		var moreBtn = document.getElementById('eclipse-more');
		var expanded = false;

		function matches(item, type, value) {
			if (type === 'all') {
				return true;
			}
			return (item.getAttribute('data-' + type) || '') === value;
		}

		function activeTab() {
			return catalogue.querySelector('.eclipse-tabs__tab.is-active') || tabs[0];
		}

		function render() {
			var tab = activeTab();
			var type = tab.getAttribute('data-type');
			var value = tab.getAttribute('data-value');
			var shown = 0;
			var total = 0;

			items.forEach(function (item) {
				var ok = matches(item, type, value);
				if (ok) {
					total++;
				}
				var visible = ok && (expanded || shown < LIMIT);
				if (visible) {
					shown++;
				}
				item.style.display = visible ? '' : 'none';
			});

			if (moreBtn) {
				moreBtn.hidden = expanded || total <= LIMIT;
			}
		}

		tabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				tabs.forEach(function (t) { t.classList.remove('is-active'); });
				tab.classList.add('is-active');
				expanded = false; // volver al estado colapsado al cambiar de filtro
				render();
			});
		});

		if (moreBtn) {
			moreBtn.addEventListener('click', function () {
				expanded = true;
				render();
			});
		}

		// Filtro precargado desde el hash (#tab=ciudad:Bilbao), p. ej. al llegar
		// desde el desplegable de destinos del detalle de experiencia.
		var hashMatch = /^#tab=(ciudad|pais):(.+)$/.exec(window.location.hash || '');
		if (hashMatch) {
			var wantedType = hashMatch[1];
			var wantedValue = decodeURIComponent(hashMatch[2]);
			tabs.forEach(function (tab) {
				if (tab.getAttribute('data-type') === wantedType && tab.getAttribute('data-value') === wantedValue) {
					tabs.forEach(function (t) { t.classList.remove('is-active'); });
					tab.classList.add('is-active');
				}
			});
			catalogue.scrollIntoView();
		}

		render();
	});
})();
